import { render, staticRenderFns } from "./Relaxed.vue?vue&type=template&id=dd8de378&scoped=true"
import script from "./Relaxed.vue?vue&type=script&lang=js"
export * from "./Relaxed.vue?vue&type=script&lang=js"
import style0 from "./Relaxed.vue?vue&type=style&index=0&id=dd8de378&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8de378",
  null
  
)

export default component.exports